import SvgIcon from "@/components/ui/SvgIcon";
import { UI_STYLES } from "@/styles/uiStyles";
import send from "@/assets/img/icons/ic_send.svg";

interface BottomInputChatProps {
    isEnabled: boolean;
    text: string;
    onChangeText: (text: string) => void;
    onSend: () => void;
}

const BottomInputChat = ({isEnabled, text, onChangeText, onSend}: BottomInputChatProps) => {
    return (
        <div className={`w-full p-4 ${UI_STYLES.bgDarkBlue4} w-full `}>


        <div className="flex flex-row items-center mx-auto max-w-md gap-2 w-full">
        <input
          type="text"
          disabled={!isEnabled}
          value={isEnabled ? text : "Чат недоступен"} 
          placeholder={isEnabled ? "Напишите сообщение" : "Чат недоступен"}
          onChange={(e) => onChangeText(e.target.value)}
          className={`w-full text-white/40 rounded-lg py-3 px-4  outline-none max-w-md ${UI_STYLES.bgDarkBlue} `}
        />
        <button
          className="w-[56px] h-full flex items-center justify-center rounded-full  transition flex-shrink-0  "
          onClick={onSend}
          aria-label="Назад"
          type="button"
        >
          <SvgIcon
            src={send}
            className="hover:bg-white/10 rounded-full"
            size={40}
          />
        </button>
      </div>
      </div>
    )
}

export default BottomInputChat;